import { render, staticRenderFns } from "./TapStationMediaForm.vue?vue&type=template&id=208d1a39&scoped=true&"
import script from "./TapStationMediaForm.vue?vue&type=script&lang=js&"
export * from "./TapStationMediaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208d1a39",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('208d1a39')) {
      api.createRecord('208d1a39', component.options)
    } else {
      api.reload('208d1a39', component.options)
    }
    module.hot.accept("./TapStationMediaForm.vue?vue&type=template&id=208d1a39&scoped=true&", function () {
      api.rerender('208d1a39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/product/components/TapStationMediaForm.vue"
export default component.exports